function setAltTags() {
     $("div.kl-private-reset-css-Xuajs1 h1>span:empty").append('<span style="display:none;">.</span>');
  $("div.kl-private-reset-css-Xuajs1 h1").append('<span style="display:none;">.</span>');
    $("div.tt-post-single img").each(function() {
        if ($(this).attr("alt") === undefined || $(this).attr("alt") === "") {
            $(this).attr("alt", "blog images");
        }
    });
}
jQuery(document).ready(function($) {
  $('button[type="submit"].tt-btn-search').append('<span style="display:none;">.</span>');
$('button.tt-btn-close.icon-f-84').append('<span style="display:none;">.</span>');
$('button[type="button"].close[data-dismiss="modal"]').append('<span style="display:none;">.</span>');
  $('input.notify-pn-bk-stock-input-email').attr('aria-label', 'Enter email address');
// Set aria-label for the first image
$('img[data-mainimage="//www.turmerry.com/cdn/shop/articles/Sleep_Hygiene-Key_to_Healthy_Sleep-main_image_respimgsize.jpg?v=1722243452"]').parent('a').attr('aria-label', 'Sleep Hygiene: Key to Healthy Sleep');
$('div.stamped-reviews-title>a').attr("aria-label","review title");
 
let Intervaltime_task;
let counter_task = 0; 


try {
    Intervaltime_task = setInterval(GenerateAriaLabelFortask, 500);
}
catch (err) {
  
}


function GenerateAriaLabelFortask() {
   
   counter_task++;


   
    if (   $("div.stamped-visual-gallery-media-block>a").length) {

$('div.stamped-reviews-title>a').attr("aria-label","review title");
       $("div.stamped-visual-gallery-media-block>a").attr("aria-label","review title");
      $("a[onclick^='StampedWallPhotosFn']").attr("aria-label","play button");
        clearInterval(Intervaltime_task);
       
    }
    
  
    if (counter_task >= 20) {
        clearInterval(Intervaltime_task);
       
    }
}
  
// Set aria-label for the second image
$('img[data-mainimage="//www.turmerry.com/cdn/shop/articles/Master_bedroom_ideas-main-image_respimgsize.jpg?v=1719323887"]').parent('a').attr('aria-label', 'Master bedroom ideas');
// Set aria-label for the first image
$('img[data-mainimage="//www.turmerry.com/cdn/shop/articles/Sleep_Hygiene-Key_to_Healthy_Sleep-main_image_respimgsize.jpg?v=1722243452"]').parent('a').attr('aria-label', 'Sleep Hygiene: Key to Healthy Sleep');
$("h3.t_ft_blog_h3:empty").append('<span style="display:none;">.</span>');
  $('img[datalazy-src*="Mattress_Sizes_Chart_and_Bed_Dimensions.jpg"]').attr('alt', 'Mattress Sizes Chart and Bed Dimensions');
    $('img[src*="Mattress_Sizes_Chart_and_Bed_Dimensions.jpg"]').attr('alt', 'Mattress Sizes Chart and Bed Dimensions');
$("h3.t_ft_blog_h3>strong:empty").append('<span style="display:none;">.</span>');
$('img[src="https://cdn.shopify.com/s/files/1/0255/9777/1885/files/Is-Amazon-the-Best-Place-to-Buy-Mattresses-2.jpg"]').attr('alt', 'Amazon opened on laptop');
$('img[src="https://cdn.shopify.com/s/files/1/0255/9777/1885/files/King_vs_California_King_ad05488f-8b8e-48c5-849a-523d8ea8b73d.jpg?v=1697165901"]').attr('alt', 'Women and children smiling with hands resting on a pillow');
$('img[src="https://cdn.shopify.com/s/files/1/0255/9777/1885/files/Twin_vs_Full_vs_Queen_Mattress_Size_Comparison.jpg?v=1697165992"]').attr('alt', 'Woman taking a nap with hands on head');
$('img[src="https://cdn.shopify.com/s/files/1/0255/9777/1885/files/Twin_Vs_Twin_XL_Mattress_Size_Comparison.jpg?v=1697165792"]').attr('alt', 'Twin vs Twin XL Mattress Size Comparison');

 $("h4:empty").append('<span style="display:none;">.</span>');
$("table.tt_mt_comp_table thead tr th:first:empty").append("<span style='display:none;'>.</span>");

 $("a[href='https://www.turmerry.com/blogs/dreamerry/latex-mattress-guide-all-questions-answered']").attr("aria-label", "Latex Mattress Guide - All Questions Answered");
$("a[href='https://www.turmerry.com/blogs/dreamerry/how-to-sleep-on-your-stomach']").attr("aria-label", "How to Sleep on Your Stomach");
$("input[name='contact[name]']").attr("aria-label", "Enter your name");
$("input[name='contact[email]']").attr("aria-label", "Enter your email");
$("input[name='contact[phone]']").attr("aria-label", "Enter your phone");
$("input[name='contact[order]']").attr("aria-label", "Enter your order number");
$("textarea[name='contact[body]']").attr("aria-label", "Enter your message");
$("input[name='customer[email]']").attr("aria-label", "Enter your email address");
$("label[for='loginInputName']").removeAttr("for");
$("input[name='email']").attr("aria-label","Enter your email address");
  $("input[name='customer[first_name]']").attr("aria-label", "Enter your first name");

$('img[src="https://cdn.shopify.com/s/files/1/0255/9777/1885/files/King_vs_Split_King_Mattress_Size.jpg?v=1697166571"]').attr('alt', 'King vs Split King Mattress Size');
$('img[src="https://cdn.shopify.com/s/files/1/0255/9777/1885/files/choosing-the-best-cooling-mattress-toppers-for-night-sweats-main-image.jpg?v=1669803557"]').attr('alt', 'Choosing the Best Cooling Mattress Toppers for Night Sweats');
$('img[src="https://cdn.shopify.com/s/files/1/0255/9777/1885/files/best-mattress-topper-for-back-pain-main-image.jpg?v=1669803634"]').attr('alt', 'Woman looking at watch and smiling');
$('img[src="https://cdn.shopify.com/s/files/1/0255/9777/1885/files/best-time-to-buy-a-mattress-main-image.jpg?v=1669803693"]').attr('alt', 'A man sitting on a mattress and smiling');
$('img[src*="how-do-you-extend-the-life-of-your-mattress-turmerry.jpg"]').attr('alt', 'bed with pillows with teddy on front');
$('img[src*="Full_Bed_vs_Double_Bed-Is_there_a_difference.jpg"]').attr('alt', 'Full Bed vs Double Bed - Is there a difference?');

// Set aria-label for the second image
$('img[data-mainimage="//www.turmerry.com/cdn/shop/articles/Master_bedroom_ideas-main-image_respimgsize.jpg?v=1719323887"]').parent('a').attr('aria-label', 'Master bedroom ideas');
// Set aria-label for the first image
$('img[data-mainimage="//www.turmerry.com/cdn/shop/articles/Bedroom_Ideas_with_bedroom_furniture_respimgsize.jpg?v=1716978722"]').parent('a').attr('aria-label', 'Bedroom Ideas with bedroom furniture');

// Set aria-label for the second image
$('img[data-mainimage="//www.turmerry.com/cdn/shop/articles/Night-Sweats-Causes-Home-Remedies-main-image_respimgsize.jpg?v=1716964314"]').parent('a').attr('aria-label', 'Night Sweats: Causes, Home Remedies, and More');

// Set aria-label for the third image
$('img[data-mainimage="//www.turmerry.com/cdn/shop/articles/how_to_stop_snoring_-_tips_and_treatments-main-image_respimgsize.jpg?v=1716977831"]').parent('a').attr('aria-label', 'How to stop snoring - tips and treatments');

// Set aria-label for the fourth image
$('img[data-mainimage="//www.turmerry.com/cdn/shop/articles/celebrate_earth_day_in_a_fun_way-main_image_respimgsize.jpg?v=1713775813"]').parent('a').attr('aria-label', 'Celebrate earth day in a fun way');

// Set aria-label for the fifth image
$('img[data-mainimage="//www.turmerry.com/cdn/shop/articles/drinks_that_help_you_sleep_at_night-main-image_respimgsize.jpg?v=1713441924"]').parent('a').attr('aria-label', 'Drinks that help you sleep at night');

// Set aria-label for the sixth image
$('img[data-mainimage="//www.turmerry.com/cdn/shop/articles/microsleep_occur_due_to_excessive_sleepiness_from_restricted_sleep-main-image_respimgsize.jpg?v=1712980996"]').parent('a').attr('aria-label', 'Microsleep occurs due to excessive sleepiness from restricted sleep');
$('img[srcset="//www.turmerry.com/cdn/shop/files/turmerry-logo-dark_150x.png?v=1679026708 1x, //www.turmerry.com/cdn/shop/files/turmerry-logo-dark_300x.png?v=1679026708 2x"]').attr('alt', 'Turmerry Serving Pure Living Logo');

// Set aria-label for the seventh image
$('img[data-mainimage="//www.turmerry.com/cdn/shop/articles/what_is_a_sleep_calculator-main-image_respimgsize.jpg?v=1711447069"]').parent('a').attr('aria-label', 'What is a sleep calculator');
$("#sectiontemplate--14741784920173__164941180997dfa09f1 picture>img").attr("alt","banner image");
$("#sectiontemplate--14741784920173__164941180275e67e441 picture>img").attr("alt","banner image");
  $('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/LZ2qsF/images/7888526e-7c62-4525-b69a-1738fbc30847.png"]').attr('alt', 'turmerry mattress');
  $('input[type="text"][name="quantity"]').attr('aria-label', 'Enter quantity');
$('a[href="#stamped-main-widget"]').attr("aria-label","stamped main widget");
  $("div.tt-aside-subscribe-box form.kl-private-reset-css-Xuajs1 button").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
  $("h2:empty").append("<span style='display:none'>.</span>")
let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;

 $('input[type="radio"][name^="discountOption"]').attr('aria-label', 'Select discount option');
   $('div.rbr-checkbox__container input[type="checkbox"]').attr('aria-label', 'Select checkbox option');
$("#\\33 88860").attr("aria-label","select option");
$("#\\33 88861").attr("aria-label","select option");
  $("#\\33 402804").attr("aria-label","select option");
    if ( $('#goog-gt-votingInputSrcLang').length) {
$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
      
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}
  
setTimeout(function() {
    $('input[type="radio"][name^="discountOption"]').attr('aria-label', 'Select discount option');
    $('div.rbr-checkbox__container input[type="checkbox"]').attr('aria-label', 'Select checkbox option');
    $('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/LZ2qsF/images/7888526e-7c62-4525-b69a-1738fbc30847.png"]').attr('alt', 'turmerry mattress');
  $("input[name^='discountOption']").attr("aria-label","Select disocunt option");

   $("div.kl-private-reset-css-Xuajs1 h1>span:empty").append('<span style="display:none;">.</span>');
  $("div.kl-private-reset-css-Xuajs1 h1").append('<span style="display:none;">.</span>');
}, 1000);

$('input[type="number"][name="filter.v.price.gte"]').attr('aria-label', 'Enter minimum price');
$('input[type="number"][name="filter.v.price.lte"]').attr('aria-label', 'Enter maximum price');
$('button.scrollwidget_scroll_btn__left').append('<span style="display:none">.</span>');
$('button.scrollwidget_scroll_btn__right').append('<span style="display:none">.</span>');
 
console.log( "ready!" );

let Intervaltime3;
let counter = 0; // counter to track the number of times the function is called

try {
    Intervaltime3 = setInterval(GenerateAriaLabelForPopup, 500);
}
catch (err) {
  
}

function GenerateAriaLabelForPopup() {

           $("div.kl-private-reset-css-Xuajs1 h1>span:empty").append('<span style="display:none;">.</span>');
  $("div.kl-private-reset-css-Xuajs1 h1").append('<span style="display:none;">.</span>');
    $("img[src*='King_vs_California_King']").attr("alt","women and children posing for a picture");
    // Increment the counter each time the function is called
    counter++;
 $('div.rbr-checkbox__container input[type="checkbox"]').attr('aria-label', 'Select checkbox option');
    // Check if the target element exists
    if ($("#stamped-reviews-tab").length) {
       $("h3.stamped-review-header-title:empty").append("<span style='display:none'>.</span>");
        clearInterval(Intervaltime3);
        
    }
    
    // Clear the interval if the function has been called 10 times
    if (counter >= 10) {
        clearInterval(Intervaltime3);
       
    }
}

  let Intervaltime1;
let counter1 = 0; // counter to track the number of times the function is called

try {
    Intervaltime1 = setInterval(GenerateAriaLabelForPopup1, 500);
}
catch (err) {
  
}

function GenerateAriaLabelForPopup1() {
    // Increment the counter each time the function is called
    counter++;
 $('div[class^="info_radioBtnContainer"] input[type="radio"]').attr('aria-label', 'Select radio option'); 
$('div input[class^="horizontalBundleItems_checkbox"][type="checkbox"]').attr('aria-label', 'Select checkbox option'); 
    $("a.stamped-review-title").attr("aria-label","review title");
    // Check if the target element exists
    if ($('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/LZ2qsF/images/7888526e-7c62-4525-b69a-1738fbc30847.png"]').length) {
      $('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/LZ2qsF/images/7888526e-7c62-4525-b69a-1738fbc30847.png"]').attr('alt', 'turmerry mattress');
       $("div.needsclick.kl-private-reset-css-Xuajs1>div>h1>span:empty").append('<span style="display:none;">.</span>');
     
        clearInterval(Intervaltime1);
        //console.log("iframe found");
    }
    
    // Clear the interval if the function has been called 10 times
    if (counter >= 10) {
        clearInterval(Intervaltime1);
        //console.log('Function called 10 times, clearing interval');
    }
}
  
   setAltTags();
    
    // Run after a 2-second delay to account for delayed content loading
    setTimeout(setAltTags, 1000);
    
    // Optional: Keep checking every second until all images have `alt` tags
    let altCheck = setInterval(function() {
        setAltTags();
        if ($("img[alt='']").length === 0) {
            clearInterval(altCheck);
        }
    }, 1000); 
});

document.addEventListener("DOMContentLoaded", (event) => {
     $("div.tt-aside-subscribe-box form.kl-private-reset-css-Xuajs1 button").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
setTimeout(function(){ $("img[src*='King_vs_California_King']").attr("alt","women and children posing for a picture");
                          $("div.kl-private-reset-css-Xuajs1 h1>span:empty").append('<span style="display:none;">.</span>');
  $("div.kl-private-reset-css-Xuajs1 h1").append('<span style="display:none;">.</span>');

                   
 $("img[src*='Kids_Mattress_Sizes']").attr("alt","kids mattress sizes");
                   $("img[src*='king-vs-california-king']").attr("alt","women and children posing for a picture");
                      $("img[src='https://cdn.shopify.com/s/files/1/0255/9777/1885/files/A_Detailed_Guide_on_Full_vs_Queen_Size_Mattresses.jpg?v=1697166432']").attr("alt", "Full vs Queen Size Mattresses");
 $('input[type="radio"][name^="discountOption"]').attr('aria-label', 'Select discount option');
                      $("input[class^='horizontalBundleItems_checkbox']").attr("aria-label","frequently bought together checkbox");
  $('img[src="https://cdn.shopify.com/s/files/1/0255/9777/1885/files/King_vs_California_King_ad05488f-8b8e-48c5-849a-523d8ea8b73d.jpg?v=1697165901"]').attr("alt", "Women and children posing for a picture");
                     $("img").each(function() {
    if ($(this).attr("alt") === undefined || $(this).attr("alt") === "") {
        $(this).attr("alt", " ");
    }
                     },1000)

                    
 
    $('div.rbr-checkbox__container input[type="checkbox"]').attr('aria-label', 'Select checkbox option');
$("h3.stamped-review-header-title:empty").append("<span style='display:none'>.</span>");
    $('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/LZ2qsF/images/7888526e-7c62-4525-b69a-1738fbc30847.png"]').attr('alt', 'turmerry mattress');
  
});
$("a.btn-pagination.btn-next").attr("aria-label"," goto next blog page");

});
